import { makeStyles } from "@cirrus/ui-kit"

import React from "react"
import classNames from "classnames"

import { Icon } from "@cirrus/legacy/app-components/entries/lib.js"

import cv from "@cirrus/legacy/app-components/app/styles/colors/colors-default.less"

const useStyles = makeStyles({
    icon: {
      cursor: "pointer",
      marginLeft: "5px",
      verticalAlign: "top",
      paddingLeft: "3px",
      paddingTop: "3px",

      "&$expanded": {
        paddingLeft: "0",
        paddingTop: "0",
      },

      "&:after": {
        content: '""',
        position: "absolute",
        width: "40px",
        height: "40px",
        left: "5px",
        top: "11px",
        transform: "translate(-50%, -50%) scale(0.4)",
        zIndex: 1,
        backgroundColor: cv.gray240,
        borderRadius: "50%",
        opacity: 0,
        transition: "all 0.2s",
      },

      "&:hover": {
        "&:after": {
          opacity: "0.4",
          transform: "translate(-50%, -50%) scale(1)",
        },
      },
    },

    expanded: {},
  }),
  ArrowIcon = (props) => {
    const { isExpanded, onClick, className, disabled } = props,
      classes = useStyles()

    return (
      <Icon
        className={classNames(classes.icon, className, {
          [classes.expanded]: isExpanded,
        })}
        icon={isExpanded ? "fa-sort-down" : "fa-caret-right"}
        onClick={(event_) => {
          event_.stopPropagation()
          onClick()
        }}
        disabled={disabled}
      />
    )
  }

export default ArrowIcon
